<template>
  <div class="text-labels--content">
    <div v-if="!labels.length" class="alert alert-sm alert-info mrg-t-10">
      Записи не найдены
    </div>
    <div class="labels">
      <div class="mrg-t-15">
        <div class="items" v-for="(item, index) in labels" :key="index">
          <div class="enroll item">
            {{datePhpToRus(item.date)}} - {{ minuteToTime(item.time) }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Formatter from "@/components/libraries/Formatter";

const formatter = new Formatter();

export default {
  name: "TextLabels",
  components: {},
  data() {
    return {
      labels: []
    };
  },
  props: {
    data: Array,
  },
  watch: {
    data: function(val){
      this.labels = val;
    }
  },
  computed: {

  },
  methods: {
    minuteToTime(minutes) {
      return formatter.minuteToTime(minutes);
    },
    datePhpToRus(date){
      return formatter.phpDateToRus(date);
    },
  },
  created() {}
};
</script>

<style scoped lang="less">

</style>
